module.exports = __webpack_public_path__ + "static/media/3_4.a3c3b396.png";